import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react';

import './scss/foot-pdf.scss';

interface IProps {
  show?:boolean
}
interface IState {}

const FootPdf = (props: IProps, state: IState) => {
  const { show } = props;
  useEffect(() => {
    return () => {};
  }, []);

  return (
    <section className="foot-pdf-warp" style={{ opacity:show ? 0 : 1 }}>
      <i className="iconfont icon-a-logoxinzhi foot-logo" />
      <b className="left-br"></b>
      <span className="page-num"></span>
      <b className="right-br"></b>
    </section>
  );
};

export default observer(FootPdf);
